


























































































import { Component, Mixins } from "vue-property-decorator";
import PasswordsMixin from "@/mixins/http/PasswordsMixin";
import DisplayErrors from "@/components/DisplayErrors.vue";
import RequestData from "@/store/types/RequestData";
import { RegisterHttp } from "@/utils/Decorators";
import { showToast } from "@/utils/Toast";

@Component({ components: { DisplayErrors } })
export default class ResetPassword extends Mixins(PasswordsMixin) {
  private password = "";
  private confirmPassword = "";
  private passwordResetted = false;
  private error = false;

  @RegisterHttp("reset") http!: RequestData;

  get resetToken() {
    return this.$route.query.token as string;
  }

  get passwordValid() {
    return this.password.length >= 8 && this.confirmPassword === this.password;
  }

  goToLogin() {
    this.$router.push({ name: "login" });
  }

  submit() {
    const data = {
      token: this.resetToken,
      password: this.password,
    };
    this.resetPassword(data, "reset").then(
      () => {
        this.passwordResetted = true;
      },
      (err) => {
        this.error = true;
      }
    );
  }
}
